import { useState } from 'react';
import { Card, Group, Stack, TagsInput, Text } from '@mantine/core';

const MAX_THEMES = 25;
const MAX_THEME_LENGTH = 80;

const GoogleSearchThemesInput = ({ value, onChange }) => {
  const themes = Array.isArray(value) ? value : [];
  const [droppedTooLong, setDroppedTooLong] = useState(false);
  const [droppedDuplicate, setDroppedDuplicate] = useState(false);

  const handleChange = (next) => {
    const trimmed = [];
    const seen = new Set();
    let tooLong = false;
    let duplicate = false;
    for (const raw of next) {
      const t = (raw || '').trim();
      if (!t) continue;
      if (seen.has(t)) {
        duplicate = true;
        continue;
      }
      if (t.length > MAX_THEME_LENGTH) {
        tooLong = true;
        continue;
      }
      seen.add(t);
      trimmed.push(t);
      if (trimmed.length >= MAX_THEMES) break;
    }
    setDroppedTooLong(tooLong);
    setDroppedDuplicate(duplicate);
    onChange(trimmed);
  };

  const atMax = themes.length >= MAX_THEMES;
  const errorMessages = [
    droppedTooLong ? `Each theme must be ${MAX_THEME_LENGTH} characters or fewer.` : null,
    droppedDuplicate ? 'Duplicate themes are ignored.' : null,
  ].filter(Boolean);

  return (
    <Card withBorder padding="md">
      <Stack gap="sm">
        <Group justify="space-between" align="center">
          <Text fw={500} size="lg">
            Search Themes
          </Text>
          <Text size="sm" c="dimmed">
            {themes.length}/{MAX_THEMES}
          </Text>
        </Group>
        <Text size="sm" c="dimmed">
          Tell Google which topics drive conversions for you (e.g. "running shoes for flat feet"). Search themes help
          Performance Max reach users searching for relevant intent. Up to {MAX_THEMES} themes, {MAX_THEME_LENGTH}{' '}
          characters each.
        </Text>
        <TagsInput
          clearable
          aria-label="Search Themes"
          value={themes}
          onChange={handleChange}
          maxTags={MAX_THEMES}
          placeholder={atMax ? `Maximum ${MAX_THEMES} search themes reached` : 'Type a theme and press Enter'}
          error={errorMessages.length > 0 ? errorMessages.join(' ') : null}
        />
      </Stack>
    </Card>
  );
};

export default GoogleSearchThemesInput;
